import {
  Add_Accountant_Tasks_Type,
  Get_All_Accountant_Tasks,
  Get_Error,
  Update_Specififc_Account_Task,
} from '../Types';

const intial = {
  TAsk: [],
  loading: true,
};

const Accountant_Task_Reducer = (state = intial, action) => {
  switch (action.type) {
    case Add_Accountant_Tasks_Type:
      return {
        ...state,
        TAsk: action.payload,
        loading: false,
      };
    case Get_All_Accountant_Tasks:
      return {
        ...state,
        TAsk: action.payload,
        loading: false,
      };
    case Update_Specififc_Account_Task:
      return {
        ...state,
        TAsk: action.payload,
        loading: false,
      };

    case Get_Error:
      return {
        loading: true,
        TAsk: action.payload,
      };
    default:
      return state;
  }
};

export default Accountant_Task_Reducer;
